import api from './api';

// Admin > Billing > Accounts Agent. Served by its OWN API gateway (code-accounts), routed through the shared
// CloudFront front door at /finance* — NOT /accounts*, which is the hub's chains on the default API.
const accountsAgentService = {
    // { isSuperAdmin, isApprover } for the signed-in user — what the portal may SHOW (never a 404).
    me: () => api.get('/finance/me').then(r => r.data),
    overview: () => api.get('/finance/overview').then(r => r.data),
    runs: (job) => api.get('/finance/runs', { params: job ? { job } : {} }).then(r => r.data),
    run: (id) => api.get(`/finance/runs/${id}`).then(r => r.data),
    runJob: (jobKey, params) => api.post(`/finance/jobs/${jobKey}/run`, { params }).then(r => r.data),
    setJob: (jobKey, changes) => api.put(`/finance/jobs/${jobKey}`, changes).then(r => r.data),
    ask: (question) => api.post('/finance/ask', { question }).then(r => r.data),
    actions: (status) => api.get('/finance/actions', { params: { status } }).then(r => r.data),
    approve: (id) => api.post(`/finance/actions/${id}/approve`, {}).then(r => r.data),
    reject: (id, reason) => api.post(`/finance/actions/${id}/reject`, { reason }).then(r => r.data),
    approvers: () => api.get('/finance/approvers').then(r => r.data),
    searchUsers: (q) => api.get('/finance/users', { params: { q } }).then(r => r.data),
    addApprover: (userId) => api.post('/finance/approvers', { userId }).then(r => r.data),
    removeApprover: (id) => api.delete(`/finance/approvers/${id}`).then(r => r.data),
    connectQuickBooks: () => api.post('/finance/qbo/connect', {}).then(r => r.data),
    settings: () => api.get('/finance/settings').then(r => r.data),
    saveSettings: (values) => api.put('/finance/settings', values).then(r => r.data),
    qboAccounts: () => api.get('/finance/qbo/accounts').then(r => r.data),
    vatPeriods: () => api.get('/finance/vat').then(r => r.data),
    vatPeriod: (id) => api.get(`/finance/vat/${id}`).then(r => r.data),
    vatWorkingFile: (id) => api.get(`/finance/vat/${id}/working-file`).then(r => r.data),
    markVatFiled: (id, rosReference, filedOn) => api.post(`/finance/vat/${id}/filed`, { rosReference, filedOn }).then(r => r.data),
    vatRates: () => api.get('/finance/vat/rates').then(r => r.data),
    saveVatRates: (rates) => api.put('/finance/vat/rates', { rates }).then(r => r.data),
    contracts: () => api.get('/finance/contracts').then(r => r.data),
    createContract: (c) => api.post('/finance/contracts', c).then(r => r.data),
    updateContract: (id, changes) => api.put(`/finance/contracts/${id}`, changes).then(r => r.data),
    qboCustomers: (q) => api.get('/finance/qbo/customers', { params: { q } }).then(r => r.data),
    // Admin > Billing > QuickBooks Customers: every customer, active and inactive (read-only).
    qboAllCustomers: () => api.get('/finance/qbo/customers', { params: { list: 'all' } }).then(r => r.data),
    // One customer as the hub's BILLING* fields, for the Billing tab's Fill from QuickBooks (superadmin only).
    qboCustomerBilling: (customerId) => api.get('/finance/qbo/customers', { params: { billingOf: customerId } }).then(r => r.data),
    // QuickBooks customer -> hconnect chain / hotel links (acct_customer_links). Save: [{ qboCustomerId, entityType, entityId }].
    customerLinks: () => api.get('/finance/customer-links').then(r => r.data),
    saveCustomerLinks: (links) => api.post('/finance/customer-links', { links }).then(r => r.data),
    qboItems: () => api.get('/finance/qbo/items').then(r => r.data),
    onboarding: () => api.get('/finance/onboarding').then(r => r.data),
    createOnboarding: (o) => api.post('/finance/onboarding', o).then(r => r.data),
    proposeOnboarding: (id) => api.post(`/finance/onboarding/${id}/propose`, {}).then(r => r.data),
};

export default accountsAgentService;
